import { Building, BuildingLevel, CompanyBuildingUnitView, BuildingUnit } from "../../models";
import { BuildingAction, BuildingActionTypes } from "../actions/building.actions";

export interface BuildingState {
  buildingsLookup: Building[],
  buildingLevelsLookup: BuildingLevel[],
  buildingUnitsLookup: CompanyBuildingUnitView[],
  allBuildingUnitsLookup: BuildingUnit[],
}

export const initialState: BuildingState = {
  buildingsLookup: [],
  buildingLevelsLookup: [],
  buildingUnitsLookup: [],
  allBuildingUnitsLookup: []
};

export function reducer(state = initialState, action: BuildingAction): BuildingState {
  switch (action.type) {
    case (BuildingActionTypes.LoadBuildingsSuccess): {
      return {
        ...state,
        buildingsLookup: action.payload
      }
    }

    case (BuildingActionTypes.LoadBuildingLevelsSuccess): {
      return {
        ...state,
        buildingLevelsLookup: action.payload
      }
    }

    case (BuildingActionTypes.LoadBuildingUnitsSuccess): {
      return {
        ...state,
        buildingUnitsLookup: action.payload
      }
        
    }

    case (BuildingActionTypes.LoadAllBuildingUnitsSuccess): {
      return {
        ...state,
        allBuildingUnitsLookup: action.payload
      }

    }
  }
  return state;
}

export const getBuildings = (state: BuildingState) => state.buildingsLookup;
export const getBuildingLevels = (state: BuildingState) => state.buildingLevelsLookup;
export const getBuildingUnits = (state: BuildingState) => state.buildingUnitsLookup;
export const getAllBuildingUnits = (state: BuildingState) => state.allBuildingUnitsLookup;



// WEBPACK FOOTER //
// ./src/app/core/store/reducers/building.reducers.ts